export type IntakeCallTemplatesTranslation = {
  actionError: string;
  add: string;
  cancel: string;
  content: string;
  delete: string;
  deleteConfirmation: string;
  emptyList: string;
  name: string;
  noAccess: string;
  picker: {
    append: string;
    choose: string;
    empty: string;
    preview: string;
    replace: string;
    title: string;
    use: string;
  };
  save: string;
  saveAs: {
    action: string;
    title: string;
  };
  search: string;
  selectHint: string;
  title: string;
};

export const intakeCallTemplatesTranslation: IntakeCallTemplatesTranslation = {
  actionError: 'Saving or deleting the template failed. Try again.',
  add: 'New template',
  cancel: 'Cancel',
  content: 'Intake call',
  delete: 'Delete',
  deleteConfirmation:
    'Delete this template? Processes that used it keep their own copy of the intake call.',
  emptyList: 'No templates yet',
  name: 'Name',
  noAccess: 'Only the author or an administrator can change this template.',
  picker: {
    append: 'Append',
    choose: 'Choose from library',
    empty: 'No templates match the search',
    preview: 'Select a template to see its content',
    replace: 'Replace',
    title: 'Intake call library',
    use: 'Use template',
  },
  save: 'Save',
  saveAs: {
    action: 'Save as template',
    title: 'Save the intake call as a template',
  },
  search: 'Search by name or content',
  selectHint: 'Select a template or add a new one',
  title: 'Intake call library',
};
